<template>
    <v-container>
      <!--- BOTON PARA REINCORPORACION -->
          <!-- <div v-if="solicitud_reincorporar && !solicitud_refrendar && !has_reincorporacion">
            <v-alert
              colored-border
              border="left"
              elevation="2"
              color="teal"
              icon="mdi-content-copy"
            >
              <v-row align="center">
                <v-col class="grow"><strong>
                  Si desea reincorporarse para el siguiente periodo 2024-2025 de click en el boton Reincorporar.<br>
                  Al generar una Reincorporación se mostrara la solicitud con los datos cargados en su última participación.</strong>
                </v-col>
                <v-col class="shrink">
                  <v-btn
                  dark
                  color="teal"
                  @click="refrendarSolicitud()"
                  >
                  Reincorporar
                </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </div> -->
          <!--- BOTON PARA REFRENDO -->
          <!-- <div v-if="solicitud_refrendar && !solicitud_reincorporar &&  !has_refrendo"> -->
          <div v-if="solicitud_refrendar && !has_refrendo && peritoEditSolicitud">
            <v-alert
              colored-border
              border="left"
              elevation="2"
              color="teal"
              icon="mdi-content-copy"
            >
              <v-row align="center">
                <v-col class="grow"><strong>
                  Si desea refrendar para el siguiente periodo {{ periodo_refrendo.nombre }} de click en el boton Refrendar.<br>
                  Al generar un Refrendo se mostrara la solicitud con los datos cargados en su última participación.</strong>
                </v-col>
                <v-col class="shrink">
                  <v-btn
                  dark
                  color="teal"
                  @click="refrendarSolicitud()"
                  >
                  Refrendar
                </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </div>
      <!--- IR A LA SECCION DE REFRENDO -->
          <div v-if="has_refrendo && peritoEditSolicitud">
            <v-alert
              color="indigo"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-view-list"
            >
            <v-row align="center">
              <v-col class="grow">
              <strong class="font-weight-bold">Usted ha iniciado el proceso de refrendo para el periodo {{ periodo_refrendo.nombre }}.<br>
                Puede consultar su solicitud dando click en VER MI REFRENDO</strong>
              </v-col>
              <v-col class="shrink">
                <v-btn
                  dark
                  color="indigo"
                  to="/refrendo"
                >
                 Ver Mi Refrendo
                </v-btn>
              </v-col>
            </v-row>
            </v-alert>
          </div>
          <!-- FIN MENSAJE CUANDO SI EXISTE REFRENDO -->
          <!-- IR A LA SECCION DE REINCORPORACION -->
          <!-- <div v-if="has_reincorporacion">
            <v-alert
              color="indigo"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-view-list"
            >
            <v-row align="center">
              <v-col class="grow">
              <strong class="font-weight-bold">Usted ha iniciado el proceso de reincorporación para el periodo 2024-2025.<br>
                Puede consultar su solicitud dando click en VER MI REINCORPORACIÓN</strong>
              </v-col>
              <v-col class="shrink">
                <v-btn
                  dark
                  color="indigo"
                  to="/refrendo"
                >
                 Ver Mi Reincorporación
                </v-btn>
              </v-col>
            </v-row>
            </v-alert>
          </div> -->
      <!-- FIN MENSAJE CUANDO SI EXISTE REINCORPORACION -->

      <v-row class="mt-5">
        <v-col cols="12">
          <p class="text-center font-weight-black">INFORMACION RELACIONADA DEL PERIODO {{periodo.nombre}}</p>
        </v-col>
      </v-row>
        <v-row>
            <v-col cols="12" md="6">
              <v-card
                elevation="7"
                color="#EEEEEE"
                class="mt-3"
              >
                <div class="d-flex flex-no-wrap justify-space-between">
                    <v-card-title class="headline"></v-card-title>
                    <v-card-text>
                      <p class="title font-weight-bold mb-0 text-center">
                       Perito </p>
                      <v-divider></v-divider>
                      <p class="title font-weight-bold mb-0 text-center mt-3">{{currentUser.nombre}} {{currentUser.primer_apellido}} {{currentUser.segundo_apellido}}</p>

                      <ul class="mt-3">
                          <li class="mt-3"><b>Fecha Nacimiento: </b>
                            {{ currentUser.fec_nacimiento | formatDate }}
                          </li>
                          <li class="mt-3"><b>E-mail: </b>{{currentUser.email_contacto}}</li>
                          <li class="mt-3"><b>Folio: </b>{{currentUser.folio}}</li><br><br>
                      </ul>
                    </v-card-text>
                  <v-avatar
                    class="ma-3"
                    size="125"
                    color="white"
                  >
                    <v-icon x-large color="orange">mdi-account</v-icon>
                  </v-avatar>
                </div>
                <v-card-actions class="mx-4">
                  <v-btn
                    text
                    color="deep-purple accent-4"
                    to="/perito/show"
                  >
                    Datos Personales
                  </v-btn>
                  </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
               <v-card
                elevation="7"
                color="#EEEEEE"
                class="mt-3"
              >
                <div class="d-flex flex-no-wrap justify-space-between" style="min-height: 238px;">
                  <v-card-title
                    class="headline"
                  ></v-card-title>
                  <v-card-text>
                    <p class="title font-weight-bold mb-0 text-center">
                      Informes
                    </p>
                    <v-divider></v-divider>
                    <ul class="mt-3">
                        <li v-for="(entrega, index) in fechasEntregasInformes" :key="'fecha_entrega_'+index">
                          {{entrega.titulo}} ({{entrega.descripcion}}) <br>
                          <b>{{entrega.pivot.fecha_inicial | formatDate}} al {{entrega.pivot.fecha_final | formatDate}}</b><br>
                        </li>
                    </ul>
                  </v-card-text>
                  <v-avatar
                    class="ma-3"
                    size="125"
                    color="white"
                  >
                    <v-icon x-large color="teal">mdi-calendar</v-icon>
                  </v-avatar>
                </div>
                <v-card-actions class="mx-4">
                  <v-btn text color="deep-purple accent-4" to = "/informes">
                    Ir a Informes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import {state} from "../store/modules/periodos";
  const Swal = require('sweetalert2');

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: true,
      // habilitado: '',
      periodo: '',
      tipo:'',
      // fecha_presenta: '',
      periodo_actual: null,// Cambiar id PERIODO al actual
      periodo_refrendo: null,
      has_refrendo: false,  //para manejar elmensaje de refrendo
      // has_reincorporacion: false,  //para manejar elmensaje de reincorporación
      solicitud_refrendar:false, //existen solicitudes del perito como para saber si puede refrendar
      // solicitud_reincorporar:false //existen solicitudes diferentes al periodo actual
    }),

    mounted(){
      this.getPeriodos();
      this.getSolicitudesDelPerito();
    },
    computed: {
      peritoEditSolicitud () {
        var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        const dateActual = localISOTime.split('T')[0]
        let dateCierre = null
        if (this.periodo_refrendo) {
          dateCierre = this.periodo_refrendo.fecha_cierre
        }
        // console.log('dateActual',localISOTime);
        // console.log('dateCierre',dateCierre);
        if (!dateActual || !dateCierre) return false
        var date_actual = new Date(dateActual).getTime();
        var date_cierre = new Date(dateCierre).getTime();
        // console.log('date_actual', date_actual);
        // console.log('date_cierre', date_cierre);
        if (date_actual <= date_cierre) {
          return true
        } else {
          return false
        }
      },
      ...mapGetters(["roleUser", "isLoggedIn", "currentUser", 'permisosList',"listPeriodos", "fechasEntregasInformes"])
    },
    filters: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
    },
    methods: {
      getPeriodos() {
        this.$store.dispatch("GET_PERIODOS",  { url: "periodos" } ).then(response => {
          this.listPeriodos.forEach(element => {
            if (element.activo == 1) {
              this.periodo = element
              this.periodo_actual = element.id
            }
            if (element.activo && element.activo == 3) {
              this.periodo_refrendo = element
            }
          });
          let userLogged =  JSON.parse(localStorage.getItem("user"))
          userLogged.perito_id = Number(userLogged.id);
          userLogged.periodo_id = Number(this.periodo.id);
          localStorage.setItem("user", JSON.stringify(userLogged));
          this.getFechasEntregas(userLogged.periodo_id);
        })
        .catch(err => {
          console.log(err);
        });
      },
      getFechasEntregas(periodoId) {
        this.$store.dispatch("GET_FECHAS_ENTREGAS_INFORMES",  { url: "/periodo/" + periodoId + "/cuatrimestres" } ).then(response => {
        })
        .catch(err => {
          console.log(err);
        });
      },
      refrendarSolicitud(){
        var title = this.solicitud_refrendar ? '¿Desea Refrendar?' : '¿Desea Reincorporar?'
        this.$swal({
          title: title,
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.value) {
          this.$store.dispatch("GET_REFRENDO",  { url: "/perito/"+this.currentUser.id+"/refrendo"})
          .then(response => {
            // console.log(response.data.data.solicitud);
             //console.log("del refrendo cuando se ejecuta",response);
            localStorage.setItem("solicitud_refrendo", JSON.stringify(response.data.data.solicitud));
            // var title = title ? '¿Desea Refrendar?' : '¿Desea Reincorporar?'
            Swal.fire({
                icon: 'success',
                title: 'Se Creó Solicitud Correctamente.',
                confirmButtonText: "Aceptar"
              })
              this.$router.push('/refrendo');
            })
            .catch(err => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response.data.message,
                confirmButtonText: "Aceptar"
              });
              // this.loading = false;
              // this.close()
            });
          }
        })
      },
      getSolicitudesDelPerito() {
        let userLogged =  JSON.parse(localStorage.getItem("user"))
        userLogged.perito_id = Number(userLogged.id);
        //console.log("el peritoId", userLogged.perito_id)
        this.$store.dispatch("GET_SOLICITUDES",  { url: "/perito/" + userLogged.perito_id + "/solicitud"  } ).then(response => {
          // console.log(response.data.data)
          let solicitud_refrendo = null
          let last_solicitud = response.data.data.last_solicitud
          if (last_solicitud) {
            // console.log("Tiene solicitues");
            if(last_solicitud.periodo_id == this.periodo_actual && last_solicitud.habilitado == 1){
              this.solicitud_refrendar = true
              // this.solicitud_reincorporar = false
              console.log("refrendo");
            }
            // if((last_solicitud.periodo_id != this.periodo_actual) || last_solicitud.periodo_id == this.periodo_actual && last_solicitud.habilitado != 1){
            //   this.solicitud_refrendar = false
            //   this.solicitud_reincorporar = true
            //   console.log("reincorporación");
            // }
            if (last_solicitud.tipo == 2 && last_solicitud.periodo_id == this.periodo_actual + 1) {
              console.log('has refrendo');
              this.has_refrendo = true
              this.solicitud_refrendar = false
              // this.solicitud_reincorporar = false
              solicitud_refrendo = last_solicitud
            }
            // if (last_solicitud.tipo == 3 && last_solicitud.periodo_id == this.periodo_actual + 1) {
            //   console.log('has reincorporación');
            //   this.has_reincorporacion = true
            //   this.solicitud_refrendar = false
            //   this.solicitud_reincorporar = false
            //   solicitud_refrendo = last_solicitud
            // }
          }
          // console.log(solicitud_refrendo);
          localStorage.setItem("solicitud_refrendo", JSON.stringify(solicitud_refrendo));
        })
          .catch(err => {
            console.log(err);
          });
      },
    }
  }
</script>
